export default "__VITE_ASSET__hX2jx5Or__"